// =============================================================================
// src/features/analytics/analytics-insights-block-d-data.ts - Bloco D,
// "Limite de medicao" (card 10, unico achado novo da edicao). Proveniencia:
// Diario_Anexo-CardsTaticos_2026-07-25.md linhas 453-517, portado verbatim
// em 2026-07-27.
// =============================================================================

import type { AnalyticsInsightBlock, AnalyticsInsightCard } from './analytics-insights-types';

const ANALYTICS_INSIGHT_CARD_10: AnalyticsInsightCard = {
  cardNumber: 10,
  cardTitle: 'A mesma janela, medida nove horas depois, move seis métricas de três cards',
  priorityTitle: 'A mesma janela, nove horas depois, move seis métricas de três cards',
  impactScore: 4,
  classificationLabel: 'LIMITE DE MEDIÇÃO',
  evidenceBlocks: [
    {
      blockKind: 'paragraph',
      paragraphHtml:
        'As duas edições desta data leem exatamente a mesma janela — 17 a 24/07. A única diferença é o ' +
        'instante em que a base foi lida: 02h e 11h10. O tamanho da base mudou assim:',
    },
    {
      blockKind: 'table',
      columnHeaders: ['Volume da mesma janela', 'Extração das 02h', 'Extração das 11h10', 'Variação'],
      tableRows: [
        ['Comentaristas distintos', '3.708', '<strong>4.544</strong>', '<strong>+22,5%</strong>'],
        ['Publicações', '712', '<strong>1.004</strong>', '<strong>+41,0%</strong>'],
        ['Matérias', '1.463', '1.472', '+0,6%'],
      ],
    },
    {
      blockKind: 'paragraph',
      paragraphHtml:
        'O movimento não está espalhado pela janela: das 183 publicações que entraram, <strong>136 foram publicadas ' +
        'em 24/07</strong>, o último dia do período. É o acompanhamento terminando de alcançar a borda da janela.',
    },
    {
      blockKind: 'paragraph',
      paragraphHtml:
        'Seis métricas que sustentam três cards se moveram acima do piso de ruído medido, e outras ficaram paradas:',
    },
    {
      blockKind: 'table',
      columnHeaders: ['Métrica', 'Edição das 02h', 'Edição das 11h10', 'Variação'],
      tableRows: [
        ['Público não-alinhado (CARD 03)', '990', '<strong>1.384</strong>', '<strong>+39,8%</strong>'],
        ['Peças de terceiros citando o monitorado (CARD 08)', '8', '<strong>13</strong>', '<strong>+62,5%</strong>'],
        ['Perfis distintos que o citam (CARD 08)', '6', '8', '+33,3%'],
        ['Peças de terceiros citando David Almeida (CARD 08)', '39', '53', '+35,9%'],
        ['Comentaristas em comum Cidade e Wilson (CARD 01)', '65', '<strong>80</strong>', '<strong>+23,1%</strong>'],
        ['Pares autor-post da sobreposição (CARD 01)', '303', '392', '+29,4%'],
        ['Comentaristas em campo único (CARD 02)', '95,8%', '95,8%', '<strong>0,0%</strong>'],
        ['Comentário mais curtido da janela (CARD 06)', '414', '414', '<strong>0,0%</strong>'],
        ['Pico diário de matérias sobre transporte (CARD 05)', '91', '91', '<strong>0,0%</strong>'],
      ],
    },
  ],
  tacticalReadingHtml: [
    'Três consequências, e a terceira é a que importa. Primeira: os números entregues às 02h desta data ' +
      'estão superados, e qualquer decisão tomada sobre eles precisa ser reconferida contra este documento. ' +
      'Segunda: as métricas que se moveram são todas contagens absolutas de coisas coletadas, e as que não ' +
      'se moveram são todas proporções e máximos — o que confirma que o movimento é de cobertura de coleta ' +
      'e não da disputa. Terceira, e a menos óbvia: <strong>as teses dos cards não mudaram</strong>. A base própria ' +
      'continua a menor, o público não-alinhado continua sem dono, o monitorado continua o que menos existe ' +
      'em conteúdo de terceiros. O instrumento ficou mais preciso e apontou para o mesmo lugar — o que é, ' +
      'em si, a melhor validação estrutural que esta edição produziu, porque foi feita com dados que a ' +
      'edição anterior não tinha.',
    'O que este painel continua sem medir, e que protege os cards acima de leitura excessiva: o ' +
      'acompanhamento captura 10,0% dos comentários declarados nas publicações, com o teto por publicação ' +
      'fazendo a fração cair quanto mais popular o item — por isso todo card estrutural desta edição foi ' +
      'construído sobre identidade de pessoas e proporções, nunca sobre volume bruto. O contador de ' +
      'visualização é assimétrico entre perfis: nas publicações em vídeo de um adversário ele existe em 14 ' +
      'de 14 itens, e nas do monitorado em 1 de 11 — motivo pelo qual alcance nunca compara perfis neste ' +
      'documento. Respostas aninhadas não são capturadas, então não se mede se o gabinete responde à ' +
      'audiência.',
  ],
  actionCallHtml:
    'Fixar a extração diária para depois do fechamento da coleta do dia anterior, e não antes: a leitura ' +
    'das 02h media uma janela cuja borda ainda estava sendo alcançada. Enquanto isso não estiver em ' +
    'vigor, declarar o instante da extração ao lado de cada número entregue e nunca comparar duas ' +
    'edições sem conferir se foram extraídas no mesmo ponto do ciclo. Substituir a edição das 02h desta ' +
    'data pela presente.',
  confidenceLine:
    'ALTA — as duas leituras foram reproduzidas na mesma base, e a reconstrução da extração das 02h devolveu ' +
    'exatamente os volumes publicados naquela edição (3.708, 712 e 1.463), o que descarta erro de apuração como explicação',
  natureLine: 'critério permanente',
  baseLine: 'as duas extrações da mesma janela de 17 a 24/07; nenhum item da janela chegou após as 11h10',
  validityLine: 'revalidar na próxima edição · ação até 08/08/2026',
  seriesLine:
    '1ª edição · impacto 4 por exceção justificada — a régua limita LIMITE DE MEDIÇÃO a 3, salvo quando o ' +
    'defeito invalida número já entregue, que é o caso',
};

export const ANALYTICS_INSIGHTS_BLOCK_D: AnalyticsInsightBlock = {
  blockId: 'D',
  blockTitle: 'Bloco D — Limite de medição',
  blockCards: [ANALYTICS_INSIGHT_CARD_10],
};
